<template>
    <div class="header" :class="view" 
    :style="{
        background: `${colors.primary}`,
        color: colors.theme == 'dark' ? `#000` : `#fff`,
    }">
        <div class="icons-header">
            <icon-header routeName="final-equation" name="enigma" v-if="view == 'game-enigma' || view == 'final-equation'"></icon-header>
            <icon-header routeName="chat/geral" :newMessages="newMessages" name="chat" v-if="view == 'game-enigma' || view == 'final-equation'"></icon-header>
        </div>
        <div class="menu-back" @click="backRoute()" @touch="backRoute()"  v-if="view == 'chat-list' || view == 'chat'">
            <img v-if="showInfo"  src="../../assets/arrow-chat.png" alt="" class="arrow-chat">
            <span v-if="chatInitial && routerName == 'chat-initial' && showInfo" class="back">Grupo</span>
            <span v-if="view == 'chat-list'" class="back">{{$t("Sections.HeaderGame.back")}}</span>
            <div class="letter-chat" v-if="view == 'chat' ">
                <letter :letter="letter" v-if="letter != 'geral' && !chatInitial"></letter>
                <!-- <img src="../../assets/chat-icon.png" alt="" v-if="letter == 'geral'" class="icon-chat animated zoomIn"> -->
                <ChatIcon  v-if="letter == 'geral'" class="icon-chat animated zoomIn" />
            </div>                
        </div> 
        <!-- <div class="menu-header" v-if="!chatInitial">
            <a class="link-face" href="https://m.me/huddleBR/" target="_blank">
                <img v-if="view == 'game-enigma' || view == 'final-equation'" src="../../assets/decode-logo.png" alt="" class="logo">
            </a>
            <button-help v-if="view == 'game-enigma' || view == 'final-equation'"></button-help>
        </div> -->
        <div class="menu-header">
            <DecodeLogo v-if="!colors.clientLogoPath"></DecodeLogo>
            <img  v-else :src="colors.clientLogoPath" alt="" class="logo">
        </div>    
        <div v-if="chatInitial && routerName == 'chat-initial' && showInfo" @click="scrollToTop()" class="rules" style="visibility: hidden">
            <span>{{$t("Sections.HeaderGame.rules")}}</span> 
        </div>
        <div class="help" v-if="chatInitial && routerName == 'chat-initial' && showInfo">
            <a class="help-content" href="https://huddlebrasil.zendesk.com/hc/pt-br/articles/360051351931-D%C3%BAvidas-Frequentes-Decode-Game-" target="_blank"
            :style='{ color : "#000"}'>
            <span>{{$t("Sections.HeaderGame.help")}}</span>
            </a>            
        </div>        
        <div class="infos-header">
            <info-game :loader="loader" typeInfo="clock" :dataInfo="clockTime" bgColor="#ffffff"></info-game>
            <info-game v-if="showScore" typeInfo="score" :dataInfo="score" bgColor="#ffffff"></info-game>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
moment.locale('pt-br');
import DecodeLogo from '../Shared/CustomIcons/Header/logoDecode.vue'
import IconHeader from '../Shared/IconHeader.vue'
import InfoGame from '../Shared/InfoGame.vue'
import Letter from '../Shared/Letter.vue'
import Bus from '../../main.js'
import ButtonHelp from '../Buttons/ButtonHelp'
import ChatIcon from "../Shared/CustomIcons/Header/Chat.vue"
export default {
    components:{
        DecodeLogo,
        IconHeader,
        InfoGame,
        Letter,
        ButtonHelp,
        ChatIcon
    },
    computed: {
        letter(){
            return this.$route.params.letter 
        },
        clock(){
            return this.$store.state.demo.clock
        }
    },
    props: {
        view : {
            type : String
        },
        score : {
            
        },
        chatInitial : {
            type : Boolean,
            default : false
        },
        showScore : {
            type : Boolean,
            default : true
        },
        clockTime : {
            type : String
        },
        loader : {
            type : Boolean
        },
        newMessages: {
            
        }
    },
    data(){
        return{
            showInfo : true,
            colors: {}
        }
    },
    created(){
        this.colors = JSON.parse(localStorage.getItem("colors"));
        Bus.$on('showInfoInitial', this.showInfoInitial)
        this.routerName = this.$route.name
        if(this.routerName == 'chat-initial'){
            this.showInfo = false
        }
    },
    destroyed(){
        Bus.$off('showInfoInitial')
    },
    methods: {
        showInfoInitial(){
            this.showInfo = true
        },
        backRoute(){
            let routeName = this.$route.name
            if(routeName == 'chat-initial'){
                this.$router.push('/waiting-room')
                return
            }
            this.$router.go(-1)
        },
        scrollToTop(){
            Bus.$emit('scrollToTop')
        }
    }
}
</script>
<style lang="scss" scoped>

    .header{
        width: 100%;
        height: 7vh;
        min-height: 55px;
        display: flex;
        justify-content: space-between ;
        // position: relative;
        position: fixed;
        z-index:  100;
        max-width: 920px;

        .help-content{
            display: flex;
            align-items: center;
            text-decoration: none;

            &:hover{
                cursor: pointer;
            }

            span{
                border: 1px solid;
                border-radius: 40px;
                padding: 3px 19px;
                font-weight: 900;
                text-transform: uppercase;
            }
        }           

        .icons-header{

            position: absolute;
            display: flex;
            justify-content: flex-end;
            right: 5px;
            top: 40%;
            width: 33%;
        }

        .rules{
            width: calc(100% + 40%);
            display: flex;
            align-items: center;
            justify-content: center;

            span{
                font-weight: bold;
                font-size: 13px;
                color: black;
                text-transform: uppercase;
                letter-spacing: 2px;
                text-decoration: underline;
                cursor: pointer;
            }
        }

        .menu-header{

            height: 100%;
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            width: 40%;

            .link-face{
                height: 31px;
            }

            .logo{
                width: 65px;
                margin: 5px auto;
            }
        } 
        .help{
            display: flex;
            
            .help-content{
                display: flex;
                align-items: center;
                text-decoration: none;

                &:hover{
                    cursor: pointer;
                }

                span{
                    border: 1px solid;
                    border-radius: 40px;
                    padding: 3px 19px;
                    font-weight: 900;
                    text-transform: uppercase;
                }
            } 
        }
        .menu-back{

            display: flex;
            align-items: center;
            margin-left: 5%;

            .letter-chat{
                display: flex;
                align-items: center;
                width: 60px;

                .chat-icon{
                    width: 40px;
                }
            }
            
            .arrow-chat{

                height: 20px;
                margin-right: 20px;
            }

            .back{

                font-weight: 900;
                font-size: 13px;
                color: color;
                text-transform: uppercase;
                letter-spacing: 2px;
                width: 57px;
            }
        }

        .infos-header{

            height: 100%;
            display: flex;
            align-items: center;
            width: 40%;
            padding-right: 6%;

            .clock-game, .score-game{

                height: 45%;
                display: flex;
                align-items: center;
                background-color: white;
                position: relative;
                border-radius: 5px;
                width: 80px;
                margin-right: 10%;

                .clock-icon, .score-icon{

                    height: 40px;
                    position: absolute;
                    left: -15px;
                }

                .time, .score{

                    margin-left: 35%;
                    font-weight: bold;
                }
            }
        }
    }

    .game-enigma, .final-equation{

        background-color: #2af0fd;
    }

    .chat-list, .chat{
        // background-color: #6efbfe;
    }

    @media only screen and (max-width : 750px) {

        .header{

            .menu-header{

                height: 100%;
                width: 20%;

                .link-face{
                    height: 30px;
                }

                .img-menu{

                    height: 35%;
                    margin: 0 10px;
                }

                .logo{

                    // height: 100%;
                    margin-top: 3%;
                }
            }

            .infos-header{

                width: 80%;
                margin-left: 3%;
                padding: 0;

                .clock-game, .score-game{

                    height: 40%;
                    width: 55px;
                    
                    .clock-icon, .score-icon{

                        height: 30px;
                    }

                    .time, .score{

                        margin-left: 23%;
                        font-size: 0.8em;
                    }
                }
            }
        }

        .chat-list, .chat{

            .infos-header{
                justify-content: flex-end ;
            }
        }
    }

    @media only screen and (min-width : 751px) {
        .header{

            height: 65px;

            .menu-header{

                align-items: flex-start;
                padding-left: 3%;

                .logo{

                    margin: 4px 10px;
                }
            }
        }
    }
</style>
